export const isVisited = (visitedLinks: Set<string>, id: string): boolean => {
	return visitedLinks.has(id);
};
